export enum ExportFileTypeEnum {
    PDF = 1,
    CSV = 2,
    Excel = 3
}

export enum ExportFileExtension {
    PDF = '.pdf',
    CSV = '.csv',
    Excel = '.xlsx'
}
